import { HttpClient } from '../httpClient';
import Supervisor from '../models/supervisor';
import { DataResponse } from '../responses/baseResponse';
import SupervisorResponse from '../responses/payateResponse';
import SupervisorRequest from '../requests/supervisorRequest';

const httpClient = new HttpClient();

export const getSupervisorById = async (id: any) => {
  return httpClient.get<DataResponse<Supervisor>>({
    url: `/v1/Supervisors/${id}`,
    requiresToken: true,
  });
};

export const getSupervisors = async () => {
  return httpClient.get<DataResponse<Supervisor[]>>({
    url: '/v1/Supervisors',
    requiresToken: true,
  });
};

export const getSupervisorsByTherapistId = async (id: number) => {
  return httpClient.get<DataResponse<Supervisor[]>>({
    url: `/v1/Supervisors/ByTherapistId/${id}`,
    requiresToken: true,
  });
};

export const getSupervisorsByDistrictId = async (districtId: number) => {
  return httpClient.get<DataResponse<Supervisor[]>>({
    url: `/v1/Supervisors/ByDistrict/${districtId}`,
    requiresToken: true,
  });
};

export const createSupervisor = async (
  Supervisorrequest: SupervisorRequest
) => {
  return httpClient.post<SupervisorResponse>({
    url: '/v1/admin/Supervisors',
    payload: Supervisorrequest,
    requiresToken: true,
  });
};

export const updateSupervisor = async (
  SupervisorId: number,
  Supervisorrequest: SupervisorRequest
) => {
  return httpClient.put<SupervisorResponse>({
    url: `/v1/admin/Supervisors/${SupervisorId}`,
    payload: Supervisorrequest,
    requiresToken: true,
  });
};

export const deleteSupervisor = async (SupervisorId: number) => {
  return httpClient.delete<SupervisorResponse>({
    url: `/v1/admin/Supervisors/${SupervisorId}`,
    requiresToken: true,
  });
};
